<template>
  <li
    class="tree-view-wrapper"
  >
    <ul
      class="cat-list"
    >
      <li class="pointer-cursor">
        <span
          @click.stop.prevent="emitSelected(item.id)"
          class="pe-1"
          :class="{
            'main-category': selectedId === item.id,
          }"
        >
          {{ item.label }}
        </span>
        <span>({{ getNumberOfArticles(item) }})</span>
        <span class="ps-1" @click="toggle" v-if="isFolder">[{{ isListOpen ? '-' : '+' }}]</span>
      </li>
    </ul>
    <ul class="cat-list" v-show="isListOpen" v-if="isFolder" @click.stop.prevent>
      <tree-view
        class="item"
        v-for="(child, index) in item.children"
        :key="index"
        :item="child"
        :is-open="isOpenFilter(child)"
        :selected-id="selectedId"
        @selected="emitSelected"
      ></tree-view>
    </ul>
  </li>
</template>
<script>
export default {
  name: 'TreeView',
  props: {
    item: Object,
    isOpen: Boolean,
    selectedId: Number,
  },
  data() {
    return {
      isListOpen: this.isOpen,
    };
  },
  computed: {
    isFolder() {
      return this.item.children && this.item.children.length;
    },
  },
  methods: {
    toggle() {
      if (this.isFolder) {
        this.isListOpen = !this.isListOpen;
      }
    },
    isOpenFilter(item) {
      const routeId = parseInt(this.$route.params.id, 10);
      if (item.id === routeId) {
        return true;
      }
      if (item.children?.length) {
        for (let i = 0; i < item.children?.length; i += 1) {
          const foundCat = this.isOpenFilter(item.children[i]);
          if (foundCat) {
            return true;
          }
        }
      }
      return false;
    },
    getNumberOfArticles(obj) {
      let count = obj.numberOfArticles || 0; // count the number of articles in the current object
      if (obj.children) { // if there are child objects, count their articles recursively
        for (let i = 0; i < obj.children.length; i += 1) {
          count += this.getNumberOfArticles(obj.children[i]);
        }
      }
      return count;
    },
    emitSelected(id) {
      this.$emit('selected', id);
    },
  },
};
</script>
<style lang="scss" scoped>
.cat-list {
  list-style: none;

  &:first-of-type{
    padding-left: 0;
  }
  padding-left: 0.5rem;
}
.item {
  padding-left: 0.5rem;
  // margin: 1rem;
  font-weight: normal;
  list-style: none;
}

.tree-view-wrapper {
  margin-bottom: 0.5rem;
  list-style: none;
}

.router-link-exact-active.active {
  font-weight: bold;
}

.pointer-cursor {
  cursor: pointer;
}

li a.active,
.main-category  {
  color: #000;
}
</style>
